<template>
	<div class="knd-wie-zei-het">
		<div class="knd-paragraaf">

      <h3>Wie deed de uitspraak?</h3>
      
      <blockquote class="knd-quote">
        {{ data.uitspraak }}
      </blockquote>
      
      <div class="knd-vraag m-b-xxl">
        Tap op de politicus die volgens jou de uitspraak heeft gedaan
      </div>
      
      <div class="multiple-options multiple-persons m-b-xxl">
        <div 
          v-for="(optie, index) in question.opties" 
          class="multiple-option person" 
          :key="'optie' + index"
        >
        <input 
          type="radio" 
          :id="'question-' + data.id +'-answer-' + index" 
          @change="onSelect(optie, index)"
          :disabled="answer.answered"
          class="input-hidden"
          :value="index" 
          :checked="answer.value && answer.value.person && person.id === optie.id"
        />
        
        <label 
          class="hover-animation"
          :for="'question-' + data.id +'-answer-' + index" 
        > 
        <img
        class="lazy"
        :alt="optie.naam"
        :src="baseUrl + optie.afbeelding[0].mobile_url"
        />
        <div class="question-name">
          
          <div class="person-name">{{optie.naam}}</div>
          
          <div class="question-name">{{optie.partij[0].titel}}</div>
          
          <div 
          class="question-feedback feedback-icon"
          :class="[answer.answered ? question.antwoord[0].id === optie.id ? 'correct' : 'incorrect' : '']"
          ></div>
          
        </div>
      </label>
    </div>
  </div>

    <Collapse class="feedback" :when="answer.value && answer.value.person"> 

      <h3>Klopt de uitspraak?</h3>

      <Stelling 
        style="--stelling-color: #000"
        :correct-answer="question.klopt.antwoord" 
        :answer="answer.value ? answer.value.stelling : {}"
        :on-click="onClickStelling" 
        :id="question.id"
        class="m-b-xl" 
        />

      <Uitklap 
        :collapse="answer.value && answer.value.stelling"
        :correct="undefined"
        :feedback="data.feedback"                               
      >
        <p>{{ feedbackText }}</p>
      </Uitklap>
    </Collapse>

		</div>
	</div>
</template>

<script>
import { toRefs, ref } from 'vue';
import { useStore } from 'vuex';
import Uitklap from '@/components/uitklap';
import { Collapse } from 'vue-collapsed';

import Stelling from '@/components/stelling';

export default {
	name: 'WieZeiHet',
  components: {Uitklap, Stelling, Collapse},
  props: {
      data: Object,
      question: Object,
      answer: Object
    },
  setup(props) {
		const store = useStore();
    const { data, question } = toRefs(props);
    let feedbackText = ref('');

    const correct = ref(undefined);
    const optieObj = ref(undefined);
    const person = ref(props.answer.value? props.answer.value.person : {});

    const baseUrl = process.env.VUE_APP_PBASE;

    if(props.answer.value && props.answer.value.stelling) {
      getFeedback(props.answer.value.person, props.answer.value.stelling);
    }

    const onSelect = (optie, index) => {      
      person.value.correct = optie.id === question.value.antwoord[0].id;
      person.value.id = optie.id;
      person.value.answered = true;

      store.dispatch('saveAnswer', {id: data.value.id, value: {person}, answered: false });

      optieObj.value = optie;
    }
    
    const onClickStelling = (payload) => {
      correct.value = payload.correct ? true : false;
      let answers = {};
      answers.person = person.value;
      answers.stelling = payload;
      answers.stelling.answered = true;

      store.dispatch('saveAnswer', {id: data.value.id, value: answers, correct: correct.value, answered: true });

      getFeedback(answers.person, answers.stelling);
    }

    function getFeedback(person, payload) {
      let s = '';
      if(person.correct && payload.correct) { 
        s = "Goed!";
      } else if(!person.correct && !payload.correct) { 
        s = "Fout!";
      }
      else if(person.correct && payload.correct === false) {
        s = "Fout! Al heb je wel de goede politicus geselecteerd.";
      } else if (person.correct === false && payload.correct) {
        s = "Goed! Al heb je de verkeerde politicus geselecteerd.";
      }

      feedbackText.value = s;
    }

    return {
      baseUrl,
      person,
      correct,
      optieObj,
      onSelect,
      onClickStelling,
      feedbackText
    }
  },
	methods: {}
}
</script>


<style lang="scss">

.knd-wie-zei-het {
  background: #28006D;
  color: #FFF;

  .multiple-option label {
    flex-direction: column;
    background: none;
  }
}
.question-name {
  font-size: 12px;
  background: $pale-pistachio;
  text-align: center;
  border-radius: 3px;
  padding: .2em;
  line-height: 1.3em;
}
.person-name {
    font-weight: bold;
  }
  
.knd-person {
  height: 150px;
  position: relative;
  

  img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    
  }
  
  .knd-person-tapped {
    width: 150px;
    left: 45%;
    top: -10px;
  }

    .knd-person-foreground {
      bottom: 0;
      left: 55%;
    }
}

.multiple-persons {
  display: flex;
  justify-content: space-between;
  // align-items: baseline;

  .multiple-option.person {
      flex: 0 1 auto;
       label {
         padding: .3rem;
       }

      .question-feedback.feedback-icon {
        right: auto;
        left: 50%;
        transform: translateX(-50%);
    }
  }

  label {
    color: #000;
  }

}
</style>